import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFetchUserBalance = (userId: string) => {
  const response = useQuery({
    queryKey: ['fetchUserBalance', userId],
    queryFn: () => api.users.fetchUserBalance(userId),
    enabled: false,
    gcTime: 0,
  })

  if (response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке баланса',
      description: response.error?.message,
    })
  }

  return response
}
